import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AVIS_GOOGLE, GOOGLE_REVIEWS_URL } from "../data/avisGoogle";
import { 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  CheckCircle, 
  AlertCircle, 
  Shield, 
  Zap, 
  Star, 
  Loader2, 
  ChevronDown,
  ChevronRight,
  Award,
  Users,
  ThumbsUp,
  Calendar,
  MessageCircle,
  ArrowRight,
  Menu,
  X
} from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_azure-seo-boost/artifacts/v4b4r58r_logo%20AT.png";

// Configuration EmailJS
const EMAILJS_SERVICE_ID = "service_rtzm46m";
const EMAILJS_TEMPLATE_ID = "template_h455el9";
const EMAILJS_PUBLIC_KEY = "Jh4VErtqqFa-xXiiT";

// Données pour les menus
const VILLES_MENU = [
  // PACA
  { nom: "Nice", url: "/nice", region: "paca" },
  { nom: "Cannes", url: "/cannes", region: "paca" },
  { nom: "Antibes", url: "/antibes", region: "paca" },
  { nom: "Grasse", url: "/grasse", region: "paca" },
  { nom: "Menton", url: "/menton", region: "paca" },
  { nom: "Cagnes-sur-Mer", url: "/cagnes-sur-mer", region: "paca" },
  { nom: "Mougins", url: "/mougins", region: "paca" },
  { nom: "Vallauris", url: "/vallauris", region: "paca" },
  { nom: "Mandelieu", url: "/mandelieu", region: "paca" },
  { nom: "Fréjus", url: "/frejus", region: "paca" },
  { nom: "Saint-Raphaël", url: "/saint-raphael", region: "paca" },
  // Île-de-France
  { nom: "Paris", url: "/paris", region: "idf" },
  { nom: "Boulogne-Billancourt", url: "/boulogne", region: "idf" },
  { nom: "Versailles", url: "/versailles", region: "idf" },
  { nom: "Créteil", url: "/creteil", region: "idf" },
  { nom: "Montreuil", url: "/montreuil", region: "idf" },
  { nom: "Argenteuil", url: "/argenteuil", region: "idf" },
  { nom: "Nanterre", url: "/nanterre", region: "idf" },
  { nom: "Levallois-Perret", url: "/levallois", region: "idf" },
  { nom: "Courbevoie", url: "/courbevoie", region: "idf" },
  { nom: "Asnières", url: "/asnieres", region: "idf" },
  { nom: "Colombes", url: "/colombes", region: "idf" },
  { nom: "Issy-les-Moulineaux", url: "/issy", region: "idf" },
  { nom: "Vincennes", url: "/vincennes", region: "idf" },
  { nom: "Neuilly-sur-Seine", url: "/neuilly", region: "idf" },
  { nom: "Saint-Denis", url: "/saint-denis", region: "idf" },
];

const SERVICES_MENU = [
  { nom: "Désinsectisation", url: "/desinsectisation" },
  { nom: "Dératisation", url: "/deratisation" },
  { nom: "Désinfection", url: "/desinfection" },
  { nom: "Punaises de lit", url: "/punaises-de-lit" },
];


// Photos d'interventions réelles
const INTERVENTIONS = [
  {
    image: "/images/9zoguxx1.webp",
    titre: "Intervention en hauteur",
    description: "Notre technicien retire un nid de frelons dans un arbre à Nice",
    type: "Guêpes/Frelons"
  },
  {
    image: "/images/4bp40k67.webp",
    titre: "Nid de frelons géant",
    description: "Retrait d'un nid de frelons de 60cm sur un balcon à Nice",
    type: "Guêpes/Frelons"
  },
  {
    image: "/images/9tra3g8h.webp",
    titre: "Nid de guêpes plafond",
    description: "Destruction d'un nid de guêpes au plafond d'un balcon",
    type: "Guêpes/Frelons"
  },
  {
    image: "/images/puz3q051.webp",
    titre: "Équipement professionnel",
    description: "Matériel de traitement : pulvérisateur et masque de protection",
    type: "Désinsectisation"
  },
  {
    image: "/images/igxsoswd.webp",
    titre: "Infestation sévère punaises",
    description: "Matelas fortement infesté - nécessite traitement thermique complet",
    type: "Punaises de lit"
  },
  {
    image: "/images/hld6i9zq.webp",
    titre: "Punaise de lit détectée",
    description: "Punaise de lit visible dans la couture du matelas - diagnostic",
    type: "Punaises de lit"
  },
  {
    image: "/images/81sqkr4m.webp",
    titre: "Nid de guêpes",
    description: "Destruction d'un nid de guêpes sous un auvent",
    type: "Guêpes/Frelons"
  },
  {
    image: "/images/xtkwzabd.webp",
    titre: "Infestation punaises de lit",
    description: "Matelas infesté de punaises de lit - traité avec succès",
    type: "Punaises de lit"
  },
  {
    image: "/images/liaj3t7n.webp",
    titre: "Infestation cafards",
    description: "Prise électrique infestée de cafards - désinsectisation complète",
    type: "Désinsectisation"
  }
];

// FAQ
const FAQ_DATA = [
  {
    question: "Sous combien de temps intervenez-vous en cas d'urgence ?",
    answer: "En cas d'urgence, nous intervenons dans les 2 heures dans les grandes villes (Nice, Paris, Cannes...). Un technicien vous rappelle sous 15 minutes pour organiser l'intervention."
  },
  {
    question: "Le devis est-il vraiment gratuit ?",
    answer: "Oui, le devis est 100% gratuit et sans engagement. Notre technicien se déplace, évalue la situation et vous propose un devis détaillé. Vous êtes libre d'accepter ou non."
  },
  {
    question: "Vos traitements sont-ils garantis ?",
    answer: "Tous nos traitements sont garantis. Si le problème persiste après notre intervention, nous revenons gratuitement jusqu'à résolution complète."
  },
  {
    question: "Intervenez-vous le week-end et les jours fériés ?",
    answer: "Oui, nous sommes disponibles 24h/24 et 7j/7, y compris les week-ends et jours fériés, sans majoration de prix."
  },
  {
    question: "Quels modes de paiement acceptez-vous ?",
    answer: "Nous acceptons les paiements par carte bancaire, chèque, virement et espèces. Le paiement s'effectue après l'intervention, une fois le travail terminé."
  }
];

// Compteur animé
function AnimatedCounter({ end, suffix = "", duration = 2000 }) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById(`counter-${end}`);
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, [end]);

  useEffect(() => {
    if (!isVisible) return;
    
    let startTime;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  }, [isVisible, end, duration]);

  return <span id={`counter-${end}`}>{count}{suffix}</span>;
}

function Home() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    departement: "",
    email: "",
    service: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.phone.trim() || !formData.departement.trim() || !formData.service) {
      setSubmitStatus('error');
      return;
    }
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const data = {
        service_id: EMAILJS_SERVICE_ID,
        template_id: EMAILJS_TEMPLATE_ID,
        user_id: EMAILJS_PUBLIC_KEY,
        template_params: {
          name: formData.name,
          phone: formData.phone,
          email: formData.email || 'Non renseigné',
          service: formData.service,
          departement: formData.departement,
          message: `[Département ${formData.departement}] ${formData.message || 'Aucun message'}`
        }
      };

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://api.emailjs.com/api/v1.0/email/send', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function() {
          if (xhr.status === 200) resolve({ status: 200 });
          else reject(new Error(`EmailJS error: ${xhr.status}`));
        };
        xhr.onerror = () => reject(new Error('Network error'));
        xhr.send(JSON.stringify(data));
      });

      setSubmitStatus('success');
      try {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/quote-submit`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ page: window.location.pathname, service: formData.service }),
        });
      } catch (err) { /* silencieux */ }
      setFormData({ name: "", phone: "", departement: "", email: "", service: "", message: "" });
    } catch (error) {
      console.error('Erreur:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (submitStatus) setSubmitStatus(null);
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Dératisation & Désinsectisation Nice (06) | Azur Tech 24h/24</title>
        <meta name="description" content="Expert anti-nuisibles à Nice et dans les Alpes-Maritimes (06). Dératisation, désinsectisation, punaises de lit, guêpes. Intervention 24h/24, devis gratuit ☎ 07 64 07 95 35" />
        <link rel="canonical" href="https://azurtech06.fr/" />
        <meta property="og:title" content="Dératisation & Désinsectisation Nice (06) | Azur Tech 24h/24" />
        <meta property="og:description" content="Expert anti-nuisibles à Nice et dans les Alpes-Maritimes (06). Intervention 24h/24, devis gratuit ☎ 07 64 07 95 35" />
        <meta property="og:url" content="https://azurtech06.fr/" />
      </Helmet>
      {/* Header */}
      <header className="bg-white shadow-sm fixed w-full top-0 z-50 border-b border-gray-100">
        {/* Top bar */}
        <div className="bg-[#0f172a] text-white py-1.5 md:py-2 text-xs md:text-sm" data-testid="trust-banner">
          <div className="container mx-auto px-4 flex justify-between items-center">
            <div className="flex items-center space-x-2 md:space-x-3 overflow-hidden">
              <Award className="w-4 h-4 text-emerald-400 flex-shrink-0" />
              <span className="truncate">Entreprise certifiée • SIREN vérifié 821 012 630</span>
              <span className="text-gray-500 hidden sm:inline">•</span>
              <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-testid="trust-banner-google-link" className="flex items-center space-x-1 text-yellow-400 hover:text-yellow-300 font-semibold flex-shrink-0">
                <span>⭐ 5/5 Avis Google</span>
              </a>
            </div>
            <div className="hidden md:flex items-center space-x-4">
              <a href="mailto:azur.tech3d@yahoo.com" className="flex items-center space-x-1 hover:text-emerald-400 transition-colors">
                <Mail className="w-4 h-4" />
                <span>azur.tech3d@yahoo.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Main nav */}
        <nav className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img src={LOGO_URL} alt="Azur Tech" className="h-12 w-auto" />
              <div className="hidden sm:block">
                <span className="text-xl font-bold text-[#0f172a] block">Azur Tech</span>
                <p className="text-xs text-gray-500">Expert Nuisibles 3D</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-6">
              {/* Services Dropdown */}
              <div className="relative group">
                <button className="flex items-center space-x-1 text-gray-700 hover:text-emerald-600 font-medium py-2 transition-colors">
                  <span>Services</span>
                  <ChevronDown className="w-4 h-4" />
                </button>
                <div className="absolute left-0 mt-0 w-52 bg-white rounded-xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                  <div className="p-2">
                    {SERVICES_MENU.map((service) => (
                      <Link
                        key={service.url}
                        to={service.url}
                        className="flex items-center px-4 py-3 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors"
                      >
                        <ChevronRight className="w-4 h-4 mr-2 text-emerald-500" />
                        {service.nom}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Villes Dropdown */}
              <div className="relative group">
                <button className="flex items-center space-x-1 text-gray-700 hover:text-emerald-600 font-medium py-2 transition-colors">
                  <span>Zones</span>
                  <ChevronDown className="w-4 h-4" />
                </button>
                <div className="absolute left-0 mt-0 w-64 bg-white rounded-xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 max-h-96 overflow-y-auto">
                  <div className="p-2">
                    <p className="px-4 py-2 text-xs font-bold text-emerald-600 uppercase tracking-wide">PACA (06, 83)</p>
                    {VILLES_MENU.filter(v => v.region === "paca").slice(0, 6).map((ville) => (
                      <Link key={ville.url} to={ville.url} className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors text-sm">
                        {ville.nom}
                      </Link>
                    ))}
                    <p className="px-4 py-2 text-xs font-bold text-emerald-600 uppercase tracking-wide mt-2 border-t pt-3">Île-de-France</p>
                    {VILLES_MENU.filter(v => v.region === "idf").slice(0, 6).map((ville) => (
                      <Link key={ville.url} to={ville.url} className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors text-sm">
                        {ville.nom}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              <Link to="/blog" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">Blog</Link>
              <Link to="/temoignages" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">Avis</Link>
              <Link to="/faq" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">FAQ</Link>
            </div>

            {/* CTA Buttons */}
            <div className="flex items-center space-x-3">
              <a 
                href="tel:0764079535" 
                className="hidden md:flex items-center space-x-2 bg-[#0f172a] hover:bg-[#1e293b] text-white px-5 py-3 rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl"
              >
                <Phone className="w-5 h-5" />
                <span>07 64 07 95 35</span>
              </a>
              <a 
                href="#devis" 
                className="hidden sm:flex items-center space-x-2 bg-emerald-500 hover:bg-emerald-600 text-white px-5 py-3 rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl"
              >
                <span>Devis gratuit</span>
                <ArrowRight className="w-4 h-4" />
              </a>
              
              {/* Mobile menu button */}
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden p-2 text-gray-700"
              >
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t pt-4">
              <div className="space-y-2">
                <p className="text-xs font-bold text-emerald-600 uppercase px-2">Services</p>
                {SERVICES_MENU.map((service) => (
                  <Link key={service.url} to={service.url} className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>
                    {service.nom}
                  </Link>
                ))}
                <div className="border-t my-3"></div>
                <p className="text-xs font-bold text-emerald-600 uppercase px-2">Zones d'intervention</p>
                <div className="grid grid-cols-2 gap-1">
                  {VILLES_MENU.filter(v => v.region === "paca").slice(0, 8).map((ville) => (
                    <Link key={ville.url} to={ville.url} className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg text-sm" onClick={() => setMobileMenuOpen(false)}>{ville.nom}</Link>
                  ))}
                </div>
                <div className="border-t my-3"></div>
                <Link to="/blog" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
                <Link to="/galerie" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>Galerie</Link>
                <Link to="/temoignages" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>Avis clients</Link>
                <Link to="/faq" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 rounded-lg" onClick={() => setMobileMenuOpen(false)}>FAQ</Link>
                <a href="tel:0764079535" className="block mx-2 mt-3 bg-emerald-500 text-white text-center font-bold py-3 rounded-xl">📞 07 64 07 95 35</a>
              </div>
            </div>
          )}
        </nav>
      </header>

      {/* Hero Section */}
      <section className="pt-32 md:pt-40 pb-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-emerald-50 to-transparent opacity-50"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-100 rounded-full filter blur-3xl opacity-30 -translate-x-1/2 translate-y-1/2"></div>
        
        <div className="container mx-auto px-4 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-xl">
              {/* Badge */}
              <div className="inline-flex items-center space-x-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Award className="w-4 h-4" />
                <span>Expert certifié • Intervention 24h/24</span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0f172a] leading-tight mb-6">
                Votre expert
                <span className="text-emerald-500"> anti-nuisibles</span>
                <br />est en chemin !
              </h1>

              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                <strong>+5 000 interventions</strong> depuis 2015 en PACA et Île-de-France.
                <br />Rats, cafards, punaises de lit... On s'occupe de tout.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <a 
                  href="tel:0764079535" 
                  className="flex items-center justify-center space-x-2 bg-[#0f172a] hover:bg-[#1e293b] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl"
                >
                  <Phone className="w-5 h-5" />
                  <span>07 64 07 95 35</span>
                </a>
                <a 
                  href="#devis" 
                  className="flex items-center justify-center space-x-2 bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl"
                >
                  <span>Demander un devis gratuit</span>
                  <ArrowRight className="w-5 h-5" />
                </a>
              </div>

              {/* Trust indicators */}
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-1">
                  {[1,2,3,4,5].map((i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                  ))}
                  <span className="ml-2 text-gray-600 font-medium">5/5</span>
                </div>
                <span className="text-gray-400">|</span>
                <span className="text-gray-600">16 avis Google vérifiés</span>
              </div>
            </div>

            {/* Hero Image / Form */}
            <div className="relative">
              <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-[#0f172a]">Devis gratuit en 5 min</h3>
                  <p className="text-gray-500 mt-1">Un expert vous rappelle rapidement</p>
                </div>

                {submitStatus === 'success' && (
                  <div className="mb-6 p-4 bg-emerald-50 border border-emerald-200 rounded-xl flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-bold text-emerald-700">Demande envoyée !</p>
                      <p className="text-sm text-emerald-600">Nous vous rappelons dans les 15 minutes.</p>
                    </div>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-start space-x-3">
                    <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-bold text-red-700">Erreur</p>
                      <p className="text-sm text-red-600">Appelez-nous directement au 07 64 07 95 35</p>
                    </div>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4" id="devis">
                  <div>
                    <input
                      type="text"
                      name="name"
                      placeholder="Votre nom *"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all"
                      data-testid="quote-form-name"
                    />
                  </div>
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Téléphone *"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all"
                      data-testid="quote-form-phone"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="departement"
                      placeholder="N° de département * (ex : 06, 75)"
                      required
                      maxLength="3"
                      value={formData.departement}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all"
                      data-testid="quote-form-departement"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Votre email (optionnel)"
                      value={formData.email}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all"
                      data-testid="quote-form-email"
                    />
                  </div>
                  <div>
                    <select
                      name="service"
                      required
                      value={formData.service}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all bg-white"
                      data-testid="quote-form-service"
                    >
                      <option value="">Type d'intervention *</option>
                      <option value="Désinsectisation">Désinsectisation (cafards, fourmis...)</option>
                      <option value="Dératisation">Dératisation (rats, souris)</option>
                      <option value="Punaises de lit">Punaises de lit</option>
                      <option value="Désinfection">Désinfection</option>
                      <option value="Guêpes/Frelons">Guêpes / Frelons</option>
                      <option value="Autre">Autre</option>
                    </select>
                  </div>
                  <div>
                    <textarea
                      name="message"
                      placeholder="Décrivez votre problème (optionnel)"
                      rows="3"
                      value={formData.message}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all resize-none"
                      data-testid="quote-form-message"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-4 rounded-xl font-bold text-lg transition-all shadow-lg hover:shadow-xl disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                  >
                    {isSubmitting ? (
                      <>
                        <Loader2 className="w-5 h-5 animate-spin" />
                        <span>Envoi...</span>
                      </>
                    ) : (
                      <>
                        <span>Recevoir mon devis gratuit</span>
                        <ArrowRight className="w-5 h-5" />
                      </>
                    )}
                  </button>
                </form>

                <p className="text-center text-sm text-gray-500 mt-4">
                  Devis 100% gratuit • Sans engagement • Réponse rapide
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Bar */}
      <section className="py-8 bg-[#0f172a]">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center text-white">
            <div className="flex flex-col items-center">
              <Clock className="w-8 h-8 text-emerald-400 mb-2" />
              <p className="font-bold">24h/24 - 7j/7</p>
              <p className="text-sm text-gray-400">Même jours fériés</p>
            </div>
            <div className="flex flex-col items-center">
              <Shield className="w-8 h-8 text-emerald-400 mb-2" />
              <p className="font-bold">Garantie résultat</p>
              <p className="text-sm text-gray-400">On revient si besoin</p>
            </div>
            <div className="flex flex-col items-center">
              <ThumbsUp className="w-8 h-8 text-emerald-400 mb-2" />
              <p className="font-bold">Devis gratuit</p>
              <p className="text-sm text-gray-400">Sans engagement</p>
            </div>
            <div className="flex flex-col items-center">
              <Zap className="w-8 h-8 text-emerald-400 mb-2" />
              <p className="font-bold">Intervention rapide</p>
              <p className="text-sm text-gray-400">Sous 2h en urgence</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-4">
              Nos services <span className="text-emerald-500">professionnels</span>
            </h2>
            <p className="text-gray-600 text-lg">
              Des solutions efficaces pour tous vos problèmes de nuisibles
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: "🐜", title: "Désinsectisation", desc: "Cafards, fourmis, blattes, puces...", url: "/desinsectisation", color: "emerald" },
              { icon: "🐀", title: "Dératisation", desc: "Rats, souris, rongeurs", url: "/deratisation", color: "blue" },
              { icon: "🛏️", title: "Punaises de lit", desc: "Traitement thermique & chimique", url: "/punaises-de-lit", color: "purple" },
              { icon: "🦠", title: "Désinfection", desc: "Virus, bactéries, odeurs", url: "/desinfection", color: "teal" }
            ].map((service, idx) => (
              <Link 
                key={idx} 
                to={service.url}
                className="group bg-gray-50 hover:bg-white rounded-2xl p-8 transition-all hover:shadow-xl border border-transparent hover:border-gray-200"
              >
                <div className="text-5xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold text-[#0f172a] mb-2 group-hover:text-emerald-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4">{service.desc}</p>
                <span className="inline-flex items-center text-emerald-600 font-medium">
                  En savoir plus
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-6">
                Pourquoi choisir <span className="text-emerald-500">Azur Tech</span> ?
              </h2>
              <p className="text-gray-600 text-lg mb-8">
                Depuis 2015, nous accompagnons les particuliers et professionnels dans la lutte contre les nuisibles en PACA et Île-de-France.
              </p>

              <div className="space-y-6">
                {[
                  { icon: <Zap className="w-6 h-6" />, title: "Intervention rapide", desc: "Un technicien chez vous sous 2h en cas d'urgence" },
                  { icon: <Users className="w-6 h-6" />, title: "Techniciens certifiés", desc: "Formés aux dernières techniques, équipés du meilleur matériel" },
                  { icon: <Shield className="w-6 h-6" />, title: "Garantie résultat", desc: "Nous revenons gratuitement si le problème persiste" },
                  { icon: <ThumbsUp className="w-6 h-6" />, title: "Prix transparent", desc: "Devis détaillé avant intervention, pas de surprise" }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center text-emerald-600 flex-shrink-0">
                      {item.icon}
                    </div>
                    <div>
                      <h3 className="font-bold text-[#0f172a] text-lg">{item.title}</h3>
                      <p className="text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {[
                { value: 5000, suffix: "+", label: "Interventions", sublabel: "depuis 2015" },
                { value: 98, suffix: "%", label: "Clients satisfaits", sublabel: "nous recommandent" },
                { value: 24, suffix: "h", label: "Disponibilité", sublabel: "7 jours sur 7" },
                { value: 2, suffix: "h", label: "Délai urgence", sublabel: "intervention rapide" }
              ].map((stat, idx) => (
                <div key={idx} className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 text-center">
                  <div className="text-4xl font-bold text-emerald-500 mb-1">
                    <AnimatedCounter end={stat.value} suffix={stat.suffix} />
                  </div>
                  <p className="font-semibold text-[#0f172a]">{stat.label}</p>
                  <p className="text-sm text-gray-500">{stat.sublabel}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Interventions récentes */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-4">
              Nos <span className="text-emerald-500">interventions récentes</span>
            </h2>
            <p className="text-gray-600 text-lg">
              Découvrez quelques exemples de nos chantiers à Nice et en PACA
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {INTERVENTIONS.slice(0, 6).map((intervention, idx) => (
              <div key={idx} className="group bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-all">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={intervention.image} 
                    alt={intervention.description || intervention.titre}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="bg-emerald-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                      {intervention.type}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-lg text-[#0f172a] mb-2">{intervention.titre}</h3>
                  <p className="text-gray-600 text-sm">{intervention.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <p className="text-gray-500 mb-4">Un problème similaire ? On peut vous aider.</p>
            <a 
              href="tel:0764079535" 
              className="inline-flex items-center space-x-2 bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-xl font-bold transition-all shadow-lg"
            >
              <Phone className="w-5 h-5" />
              <span>Appelez-nous : 07 64 07 95 35</span>
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-4">
              Ce que disent <span className="text-emerald-500">nos clients</span>
            </h2>
            <div className="flex items-center justify-center space-x-1 mb-2">
              {[1,2,3,4,5].map((i) => (
                <Star key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <div className="flex items-center justify-center space-x-2 text-gray-600">
              <span>5/5 • {AVIS_GOOGLE.length} avis vérifiés sur</span>
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              <span className="font-medium">Google</span>
            </div>
          </div>

          {/* Grille d'avis Google */}
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="home-avis-grid">
            {AVIS_GOOGLE.slice(0, 6).map((avis, idx) => (
              <div key={idx} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-shadow" data-testid={`home-avis-card-${idx}`}>
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-emerald-500 text-white flex items-center justify-center font-bold flex-shrink-0">
                      {avis.nom.charAt(0)}
                    </div>
                    <div>
                      <p className="font-bold text-[#0f172a] text-sm">{avis.nom}</p>
                      <p className="text-gray-500 text-xs">{avis.ville} • {avis.date}</p>
                    </div>
                  </div>
                  <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                </div>
                <div className="flex mb-2">
                  {[1,2,3,4,5].map((i) => (
                    <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed text-sm">"{avis.texte}"</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="https://share.google/DUrON8BOcFKaDm6vA" target="_blank" rel="noopener noreferrer" data-testid="home-avis-google-btn" className="inline-flex items-center bg-emerald-500 text-white px-6 py-3 rounded-xl font-bold hover:bg-emerald-600 transition-colors">
                ⭐ Voir nos avis Google vérifiés
              </a>
              <Link to="/temoignages" className="inline-flex items-center text-emerald-600 font-medium hover:text-emerald-700 transition-colors">
                Voir tous les avis
                <ArrowRight className="w-4 h-4 ml-1" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Zones d'intervention */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-4">
              Nos zones <span className="text-emerald-500">d'intervention</span>
            </h2>
            <p className="text-gray-600 text-lg">
              Nous intervenons rapidement dans toute la PACA et l'Île-de-France
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-[#0f172a]">PACA</h3>
                  <p className="text-gray-500">Alpes-Maritimes (06) & Var (83)</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                {VILLES_MENU.filter(v => v.region === "paca").map((ville) => (
                  <Link 
                    key={ville.url} 
                    to={ville.url}
                    className="px-3 py-1 bg-gray-100 hover:bg-emerald-100 hover:text-emerald-700 rounded-full text-sm transition-colors"
                  >
                    {ville.nom}
                  </Link>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-[#0f172a]">Île-de-France</h3>
                  <p className="text-gray-500">Paris et petite couronne</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                {VILLES_MENU.filter(v => v.region === "idf").map((ville) => (
                  <Link 
                    key={ville.url} 
                    to={ville.url}
                    className="px-3 py-1 bg-gray-100 hover:bg-emerald-100 hover:text-emerald-700 rounded-full text-sm transition-colors"
                  >
                    {ville.nom}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-4">
              Questions <span className="text-emerald-500">fréquentes</span>
            </h2>
            <p className="text-gray-600 text-lg">
              Tout ce que vous devez savoir sur nos interventions
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {FAQ_DATA.map((item, idx) => (
              <div 
                key={idx} 
                className="bg-gray-50 rounded-xl overflow-hidden border border-gray-100"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors"
                >
                  <span className="font-semibold text-[#0f172a] pr-4">{item.question}</span>
                  <ChevronDown className={`w-5 h-5 text-emerald-500 flex-shrink-0 transition-transform ${openFaq === idx ? 'rotate-180' : ''}`} />
                </button>
                {openFaq === idx && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link to="/faq" className="inline-flex items-center text-emerald-600 font-medium hover:text-emerald-700 transition-colors">
              Voir toutes les questions
              <ArrowRight className="w-4 h-4 ml-1" />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#0f172a] relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-600/20 to-transparent"></div>
        <div className="container mx-auto px-4 relative">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Un problème de nuisibles ?
              <br />
              <span className="text-emerald-400">On s'en occupe.</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8">
              Appelez-nous maintenant ou demandez un devis gratuit. Un expert vous répond en moins de 15 minutes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:0764079535" 
                className="flex items-center justify-center space-x-2 bg-white hover:bg-gray-100 text-[#0f172a] px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg"
              >
                <Phone className="w-5 h-5" />
                <span>07 64 07 95 35</span>
              </a>
              <a 
                href="#devis" 
                className="flex items-center justify-center space-x-2 bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg"
              >
                <span>Devis gratuit</span>
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white pt-16 pb-8">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img src={LOGO_URL} alt="Azur Tech" className="h-10 w-auto" />
                <div>
                  <h3 className="font-bold text-lg">Azur Tech</h3>
                  <p className="text-sm text-gray-400">Expert Nuisibles 3D</p>
                </div>
              </div>
              <p className="text-gray-400 text-sm">
                Votre partenaire de confiance pour l'élimination des nuisibles depuis 2015.
              </p>
            </div>

            <div>
              <h4 className="font-bold mb-4">Services</h4>
              <ul className="space-y-2 text-gray-400">
                {SERVICES_MENU.map((service) => (
                  <li key={service.url}>
                    <Link to={service.url} className="hover:text-emerald-400 transition-colors">{service.nom}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Liens utiles</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/blog" className="hover:text-emerald-400 transition-colors">Blog</Link></li>
                <li><Link to="/faq" className="hover:text-emerald-400 transition-colors">FAQ</Link></li>
                <li><Link to="/temoignages" className="hover:text-emerald-400 transition-colors">Avis clients</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Contact</h4>
              <ul className="space-y-3 text-gray-400">
                <li className="flex items-center space-x-2">
                  <Phone className="w-4 h-4 text-emerald-400" />
                  <a href="tel:0764079535" className="hover:text-emerald-400 transition-colors">07 64 07 95 35</a>
                </li>
                <li className="flex items-center space-x-2">
                  <Mail className="w-4 h-4 text-emerald-400" />
                  <a href="mailto:azur.tech3d@yahoo.com" className="hover:text-emerald-400 transition-colors">azur.tech3d@yahoo.com</a>
                </li>
                <li className="flex items-center space-x-2">
                  <MapPin className="w-4 h-4 text-emerald-400" />
                  <span>6 rue Miollis, 06000 Nice</span>
                </li>
                <li className="flex items-center space-x-2">
                  <MapPin className="w-4 h-4 text-emerald-400" />
                  <span>PACA & Île-de-France</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
            <p>© {new Date().getFullYear()} Azur Tech - Expert Nuisibles 3D. Tous droits réservés — SIREN 821 012 630 — <Link to="/mentions-legales" className="hover:text-emerald-400">Mentions légales</Link></p>
          </div>
        </div>
      </footer>

      {/* Sticky CTA Mobile */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 md:hidden z-50 shadow-lg">
        <div className="flex space-x-3">
          <a 
            href="tel:0764079535" 
            className="flex-1 flex items-center justify-center space-x-2 bg-[#0f172a] text-white py-3 rounded-xl font-semibold"
          >
            <Phone className="w-5 h-5" />
            <span>Appeler</span>
          </a>
          <a 
            href="#devis" 
            className="flex-1 flex items-center justify-center space-x-2 bg-emerald-500 text-white py-3 rounded-xl font-semibold"
          >
            <MessageCircle className="w-5 h-5" />
            <span>Devis gratuit</span>
          </a>
        </div>
      </div>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/33764079535?text=Bonjour, j'ai besoin d'une intervention pour "
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-20 md:bottom-6 right-4 bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110 z-40"
        aria-label="WhatsApp"
      >
        <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>
    </div>
  );
}

export default Home;
